import React from 'react';
import { Link } from 'react-router-dom';
import StaticPage, { Section, CardGrid } from './StaticPage';

export default function ListYourProperty() {
  return (
    <StaticPage title="List Your Property" subtitle="Reach thousands of verified students actively searching for accommodation across Australia.">
      <Section title="Why List on RentalX">
        <CardGrid items={[
          { title: '50,000+ Active Students', desc: 'Your listing reaches thousands of domestic and international students each month.' },
          { title: 'Verified Tenants', desc: 'All student accounts are verified. No random enquiries — only serious searchers.' },
          { title: 'Free to Start', desc: 'List your first property for free. Upgrade to Pro for priority placement and more listings.' },
          { title: 'Simple Dashboard', desc: 'Manage enquiries, update listings, and track performance from one easy dashboard.' },
        ]} />
      </Section>

      <Section title="How It Works">
        <div className="space-y-4">
          {[
            { step: '1', title: 'Create a Landlord Account', desc: 'Sign up in under 2 minutes. We\'ll verify your identity to get your Verified badge.' },
            { step: '2', title: 'Create Your Listing', desc: 'Add your property details, photos, pricing, and availability. It takes about 10 minutes.' },
            { step: '3', title: 'Receive Enquiries', desc: 'Students contact you directly through the platform. Respond to find the right tenant.' },
            { step: '4', title: 'Sign the Lease', desc: 'Use our free lease templates or your own. Collect the bond and start earning.' },
          ].map((item, i) => (
            <div key={i} className="flex gap-4 p-4 bg-sky-50 rounded-xl border border-sky-100">
              <div className="w-9 h-9 bg-[#094f6f] text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">{item.step}</div>
              <div>
                <p className="font-semibold text-gray-800">{item.title}</p>
                <p className="text-sm text-gray-600 mt-0.5">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </Section>

      <Section title="Pricing">
        <p>Start for free with 1 active listing. Upgrade to <Link to="/pricing" className="text-[#094f6f] underline font-medium">Pro (A$49/month)</Link> for up to 10 listings with priority placement, or <Link to="/pricing" className="text-[#094f6f] underline font-medium">Agency (A$149/month)</Link> for unlimited listings and API access.</p>
      </Section>

      <div className="text-center py-8">
        <Link to="/register/landlord">
          <button className="bg-[#094f6f] text-white px-10 py-4 rounded-xl font-semibold text-lg hover:bg-[#094f6f]/90 transition-colors">
            Create Your Landlord Account
          </button>
        </Link>
        <p className="text-sm text-gray-500 mt-3">Already have an account? <Link to="/login" className="text-[#094f6f] underline">Sign in</Link></p>
      </div>
    </StaticPage>
  );
}
